import styled from 'styled-components';
import { IonBackdrop, IonModal } from '@ionic/react';

export const StyledBackdrop = styled(IonBackdrop)`
  background: black;
  opacity: 0.3;
  z-index: 20007;
`;

export const StyledNeedUpdateModal = styled(IonModal)`
  --background: none;
  --box-shadow: none;
  --height: 100%;
  z-index: 20008 !important;

  .content {
    position: relative;

    width: 343px;
    height: auto;

    margin: 0 auto;
  }
`;
